import styled from "styled-components";
// import imgBg from "../assets/imgs-background/entrada.jpg";
import imgBg from "../assets/imgs-background/background1.png";

export const HomeMain = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 25%;
  min-height: 100dvh;
  height: 100dvh;
  max-height: 100dvh;
  width: 100%;
  background: rgb(76, 76, 76);
  background: linear-gradient(
    180deg,
    rgb(76, 76, 76) 0%,
    rgb(122, 122, 122) 100%
  );
  .background {
    display: flex;
    justify-content: space-between;
    /* align-items: center; */
    position: fixed;
    /* flex-direction: column; */
    gap: 30px;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    max-height: 100%;
    background-color: rgba(18, 18, 20, 0);
    backdrop-filter: blur(5px);
    padding: 20px;
    img {
      width: 280px;
      max-width: 100%;
      height: 45px;
      opacity: 70%;
    }
    div {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 35px;
      height: 50px;
      color: rgba(209, 209, 209, 1);
      cursor: pointer;
      button {
        border: none;
        font-size: 28px;
        background-color: transparent;
        color: rgba(209, 209, 209, 1);
        cursor: pointer;
      }
    }
  }
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 65%;
    height: 450px;
    max-height: 80%;
    gap: 45px;
    max-height: 100%;
    padding: 25px;
    text-align: center;
    background-color: aqua;
    h2 {
      color: white;
      font-size: 35px;
    }
    p {
      color: white;
      font-size: 25px;
    }
    .containerButtons {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 25px;
      width: 100%;
    }
    .buttons {
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        color: white;
        padding: 15px;
        font-size: 20px;
        background: rgba(140, 140, 140, 0.5);
        border-radius: 10px;
        border: none;
        backdrop-filter: blur(10.9px);
        -webkit-backdrop-filter: blur(10.9px);
        cursor: pointer;
        transition: 0.5s;
      }
      button:hover {
        background: rgba(140, 140, 140, 0.8);
      }
    }
    background: rgba(52, 52, 52, 0.6);
    box-shadow: 0 8px 32px 0 rgba(188, 188, 188, 0.15);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.18);
  }
  @media (max-width: 600px) {
    .background {
      img {
        margin-top: 5px;
        width: 200px;
        max-width: 100%;
        height: 37px;
        opacity: 60%;
      }
    }
    .container {
      width: 90%;
      h2 {
        font-size: 30px;
      }
      p {
        font-size: 18px;
      }
    }
  }
  @media (max-width: 321px) {
    .background {
      img {
        margin-top: 10px;
        width: 160px;
        max-width: 100%;
        height: 27px;
        opacity: 60%;
      }
    }
    .container {
      width: 90%;
      h2 {
        font-size: 25px;
      }
      p {
        font-size: 16px;
      }
    }
  }
`;

export const UnitStyled = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  max-height: max-content;
  width: 100%;
  background-image: url(${imgBg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  /* background: rgb(76, 76, 76);
  background: linear-gradient(
    180deg,
    rgb(76, 76, 76) 0%,
    rgb(122, 122, 122) 100%
  ); */
  .HeaderHome {
    display: flex;
    width: 100%;
    justify-content: center;
    align-items: end;
    position: absolute;
    top: 40px;
    color: rgba(194, 194, 194, 1);
    /* position: relative; */

    h2 {
      font-size: 30px;
      color: rgba(244, 244, 244, 1);
    }
    button {
      position: absolute;
      top: 1px;
      right: 3%;
      padding: 10px;
      border-radius: 10px;
      border: none;
      background-color: rgba(0, 0, 0, 0.5);
      color: rgba(203, 203, 203, 1);
      font-size: 16px;
      width: 150px;
      cursor: pointer;
    }
    button:hover {
      color: white;
      transition: 0.5s;
    }
  }
  .listUnidades {
    display: flex;
    width: 100%;
    max-width: 100%;
    padding-left: 65px;
    ul {
      display: flex;
      justify-content: center;
      width: 100%;
      height: 80%;
      flex-wrap: wrap;
      list-style: none;
      gap: 20px;
      padding: 10px;
      padding-bottom: 80px;
      .listDesativat {
        opacity: 50%;
        cursor: not-allowed;
      }
      li {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: fit-content;
        justify-content: center;
        padding: 25px;
        border-radius: 10px;
        min-width: 200px;
        width: 100%;
        max-width: 200px;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        color: rgba(226, 226, 226, 1);
        gap: 10px;
        height: 180px;
        cursor: pointer;
        border: 2px solid transparent;
        transition: 1s;
        border: 2px solid rgba(255, 255, 255, 0.37);
        img {
          width: 80px;
        }
        .icon {
          font-size: 80px;
        }
        h3 {
          text-align: center;
        }
      }
      li:hover {
        border: 2px solid rgba(229, 229, 229, 0.8);
      }
    }
  }

  .easterEgg {
    /* background-color: aqua; */
    position: absolute;
    bottom: 5px;
    width: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    right: 15px;
    opacity: 30%;
    z-index: 9999;
    img {
      width: 100%;
    }
  }
  .tabbleStatus {
    display: flex;
    flex-direction: column;
    width: 40%;
    gap: 25px;
    background: rgba(0, 0, 0, 0.48);
    border-radius: 10px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(10.9px);
    -webkit-backdrop-filter: blur(10.9px);
    padding: 40px 60px;
    margin-top: 6%;
    margin-bottom: 6%;
    h3 {
      font-size: 25px;
      color: #ebebeb;
    }
    table {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 25px;
      justify-content: center;
      align-items: center;
      tbody tr:first-child {
        cursor: pointer;
        transition: all 0.3s;
      }
      tbody tr:first-child:hover {
        color: white;
      }
      tbody {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        flex-direction: column;
        gap: 30px;
        tr {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          justify-content: space-between;
          border-bottom: 1px solid #d1d1d1;
          padding-bottom: 5px;
          color: #d0d0d0;
          font-size: 20px;
        }
      }
    }
  }
  @media (max-width: 1136px) {
    .HeaderHome {
      width: 85%;
    }
    .listUnidades {
      padding-top: 100px;
    }
    .tabbleStatus {
      width: 85%;
      margin-top: 20%;
      margin-bottom: 20%;
      tr {
        font-size: 14px;
        max-width: 100%;
      }
    }
  }
  @media (max-width: 800px) {
    align-items: end;
    .HeaderHome {
      width: 100%;
      top: 15px;
      align-items: center;
      justify-content: center;
      padding-left: 60px;
      h2 {
        font-size: 28px;
      }
      button {
        top: 40px;
      }
    }
    .listUnidades {
      padding-top: 100px;
    }
    .tabbleStatus {
      width: 85%;
      margin-top: 20%;
      margin-bottom: 20%;
      tr {
        font-size: 14px;
        max-width: 100%;
      }
    }
  }
  @media (max-width: 650px) {
    .HeaderHome {
      width: 100%;
      padding-right: 5px;
      img {
        width: 5px;
      }
    }
    .listUnidades {
      width: 100%;
      padding-left: 0;

      ul {
        /* margin-left: 100px; */
        li {
          max-width: 300px;
        }
      }
    }
    .tabbleStatus {
      width: 100%;
      background-color: azure;
    }
  }
  @media (max-width: 490px) {
    .HeaderHome {
      img {
        display: none;
      }
    }
  }
`;
